import { aplClient } from "./apiClient";
import { WorkorderLabel } from "../types/workorderLabel";

const getWorkorderLabel = async (workorderId: string) => {
    let dataUrl = `workorderlabels/${workorderId.toString()}`;
    return aplClient().get(dataUrl);
};

const saveWorkorderLabel = async (workorderId: string, workorderlabel: WorkorderLabel ) => {
    let dataUrl = `workorderlabels/${workorderId.toString()}`;
    return aplClient().put(dataUrl, workorderlabel);
};

export { getWorkorderLabel, saveWorkorderLabel };
